// src/aws-exports.js
export default {
    Auth: {
        Cognito: {
            userPoolClientId: (import.meta.env.VITE_USER_POOL_CLIENT_ID),
            userPoolId: (import.meta.env.VITE_USER_POOL_ID),
            userPoolRegion: (import.meta.env.VITE_BUCKET_REGION),
            loginWith: {
                email: true
            }
        }
    },
    API: {
        GraphQL: {
            endpoint: (import.meta.env.VITE_GRAPHQL_ENDPOINT),
            region: 'us-east-1',
            defaultAuthMode: 'userPool'
        }
    },
    Storage: {
        S3: {
            bucket: (import.meta.env.VITE_BUCKET_NAME),
            region: (import.meta.env.VITE_BUCKET_REGION)

        }
    }
}